import { OnInit, Component, Input } from "@angular/core";
import { select } from "@angular-redux/store";
import { PlanningBlock } from "../../../../models/planning-block/planning-block.interface";
import { Observable } from "rxjs";
import { ApplicationUser } from "../../../../models/application.user.interface";

@Component({
    moduleId: module.id,
    selector: 'pb-general-details',
    templateUrl: './pb-general-details.component.html',
})
export class PbGeneralDetails implements OnInit {

    @select('applicationUser') applicationUser$: Observable<ApplicationUser>;

    @Input() planningBlock: PlanningBlock;

    applicationUser: ApplicationUser;
    public enableAutocomplete: boolean = false;

    constructor() {
    }

    ngOnInit(): void {
        this.applicationUser$.subscribe((applicationUser: ApplicationUser) => {
            if (applicationUser) {
              this.applicationUser = applicationUser;
              this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
            }
          });
    }
}
